import React, { FC, useEffect } from 'react';
import { Skeleton } from 'antd';
import { WarningCircle } from 'common/svg';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { getImproveQscSummaryModel } from 'app/store/reducers/improveQsc.reducer';
import { IImproveQscSummaryParams } from 'entities/ImproveQsc/ImproveQsc.models';
import { ImproveQscSummary } from 'entities/ImproveQsc/components/ImproveQscSummary';

interface IComponentProps {
  dateRange: string;
  params?: IImproveQscSummaryParams;
}

export const ImproveQscSummaryBlock: FC<IComponentProps> = ({ dateRange, params }) => {
  const dispatch = useAppDispatch();

  const { improveQscSummaryModel, improveQscSummaryModelLoading } = useAppSelector((state) => state.improveQsc);

  useEffect(() => {
    dispatch(getImproveQscSummaryModel(params));
  }, [params?.storeCode, params?.week]);

  return (
    <div className="iqsc-block">
      <div className="iqsc-block__header">
        <span className="ff-medium fs-xs">{dateRange}</span>
        <WarningCircle className="icon-gray" />
      </div>

      <div className="iqsc-block__body">
        {improveQscSummaryModelLoading ? (
          <Skeleton active paragraph={{ rows: 4 }} title={false} />
        ) : (
          <ImproveQscSummary score={improveQscSummaryModel} />
        )}
      </div>
    </div>
  );
};
